<!-- Footer -->
<footer class="site-footer">
  <div class="container">
  <div class="row">
    <div class="col-sm-4">
      <div class="coulmn-1">
        <img src="assets/img/logo.svg">
        <p>Free assests for your next project</p>
        <a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
      </div>
    </div>
    <div class="col-sm-5">
      <ul class="menu">
        <li><a href="javascript:;">Term & Conditions</a></li>
        <li><a routerLink="/contact">Contact Us</a></li>
      </ul>
    </div>
    <div class="col-sm-3">
      <ul class="social-icons">
        <li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank” alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
        <li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
        <li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
        <li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
        <li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
      </ul>
    </div>
    <div class="col-sm-12 text-center">
      <small>copyright © 2025 Crafttor. All rights reserved</small>
    </div>
  </div>
  </div>
</footer>
